// src/components/ValueProps/ValueProps.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./About.module.css";

/* --- Ícones SVG inline (estilo flat / orgânico) ---
   Você pode manter estes inline ou extrair para arquivos:
   /src/assets/icons/temperament.svg, caracter.svg, etc.
*/
function Icon({ name, className }) {
  const { t } = useTranslation("home");
  const common = {
    className,
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
  };

  switch (name) {
    case "temperament":
      return (
        <svg {...common}>
          <rect width="48" height="48" rx="10" fill="#F2F6FF" />
          <g transform="translate(6,6)">
            <ellipse cx="10" cy="22" rx="6" ry="6" fill="#6B46FF" />
            <ellipse cx="24" cy="12" rx="5.2" ry="5.2" fill="#00B894" />
            <path
              d="M4 28 C12 22, 20 14, 30 10"
              fill="none"
              stroke="rgba(107,70,255,0.12)"
              strokeWidth="2.2"
              strokeLinecap="round"
            />
          </g>
        </svg>
      );

    case "character":
      return (
        <svg {...common}>
          <rect width="48" height="48" rx="10" fill="#FFF9F6" />
          <g transform="translate(6,6)">
            <rect
              x="2"
              y="6"
              width="28"
              height="8"
              rx="3"
              fill="#FF7A59"
              opacity="0.95"
            />
            <rect
              x="2"
              y="18"
              width="20"
              height="6"
              rx="3"
              fill="#FFBFAA"
              opacity="0.95"
            />
            <circle cx="26" cy="8" r="3.2" fill="#FF7A59" />
          </g>
        </svg>
      );

    case "processes":
      return (
        <svg {...common}>
          <rect width="48" height="48" rx="10" fill="#F6FFF8" />
          <g transform="translate(6,6)">
            <rect x="2" y="6" width="28" height="6" rx="3" fill="#00B894" />
            <rect
              x="2"
              y="18"
              width="18"
              height="6"
              rx="3"
              fill="#00B894"
              opacity="0.9"
            />
            <circle cx="8" cy="9" r="2.6" fill="#E6FFF2" />
          </g>
        </svg>
      );

    case "comic":
      return (
        <svg {...common}>
          <rect width="48" height="48" rx="10" fill="#FFF7FF" />
          <g transform="translate(6,6)">
            <rect x="2" y="6" width="28" height="18" rx="3" fill="#FFFFFF" />
            <rect x="4" y="8" width="10" height="4" rx="2" fill="#F3EEFF" />
            <rect x="16" y="8" width="10" height="4" rx="2" fill="#F3EEFF" />
            <circle cx="26" cy="22" r="2.8" fill="#4C2BD6" />
          </g>
        </svg>
      );

    case "exercises":
      return (
        <svg {...common}>
          <rect width="48" height="48" rx="10" fill="#F7FBFF" />
          <g transform="translate(6,6)">
            <rect x="2" y="6" width="28" height="10" rx="3" fill="#EDEBFF" />
            <path
              d="M6 22c6-7 14-6 18-2"
              fill="none"
              stroke="#6B46FF"
              strokeWidth="3.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="6" cy="22" r="2.6" fill="#6B46FF" />
          </g>
        </svg>
      );

    case "strengths":
      return (
        <svg {...common}>
          <rect width="48" height="48" rx="10" fill="#FFFCF6" />
          <g transform="translate(6,6)">
            <rect x="2" y="6" width="28" height="18" rx="3" fill="#FFF6E8" />
            <path
              d="M6 20 L12 26 L26 10"
              fill="none"
              stroke="#FFB020"
              strokeWidth="3.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="10" cy="24" r="2.8" fill="#FFB020" />
          </g>
        </svg>
      );

    case "domains":
      return (
        <svg {...common}>
          <rect width="48" height="48" rx="10" fill="#F8FBFF" />
          <g transform="translate(6,6)">
            <rect x="2" y="6" width="28" height="4" rx="2" fill="#EAF0FF" />
            <rect x="2" y="14" width="28" height="4" rx="2" fill="#EAF0FF" />
            <rect x="2" y="22" width="18" height="4" rx="2" fill="#EAF0FF" />
            <circle cx="34" cy="10" r="3.6" fill="#4C2BD6" />
          </g>
        </svg>
      );

    case "plan":
      return (
        <svg {...common}>
          <rect width="48" height="48" rx="10" fill="#F6FFFB" />
          <g transform="translate(6,6)">
            <rect x="2" y="6" width="28" height="6" rx="3" fill="#E9FFF2" />
            <rect x="2" y="16" width="20" height="6" rx="3" fill="#EDE7FF" />
            <rect x="2" y="26" width="14" height="6" rx="3" fill="#FEF0E6" />
            <circle cx="8" cy="9" r="2.6" fill="#00B894" />
          </g>
        </svg>
      );

    case "summary":
    default:
      return (
        <svg {...common}>
          <rect width="48" height="48" rx="10" fill="#FFF9F4" />
          <g transform="translate(6,6)">
            <rect x="2" y="6" width="28" height="6" rx="3" fill="#FFF2EA" />
            <rect x="2" y="16" width="20" height="6" rx="3" fill="#FFEFE8" />
            <circle cx="34" cy="18" r="3.2" fill="#FF7A59" />
          </g>
        </svg>
      );
  }
}

export default function About() {
  const { t } = useTranslation("home");

  const items = [
    {
      key: "temperament",
      icon: "temperament",
      title: t("aboutCard1Title"),
      text: t("aboutCard1Text"),
    },
    {
      key: "character",
      icon: "character",
      title: t("aboutCard2Title"),
      text: t("aboutCard2Text"),
    },
    {
      key: "processes",
      icon: "processes",
      title: t("aboutCard3Title"),
      text: t("aboutCard3Text"),
    },
    {
      key: "comic",
      icon: "comic",
      title: t("aboutCard4Title"),
      text: t("aboutCard4Text"),
    },
    {
      key: "exercises",
      icon: "exercises",
      title: t("aboutCard5Title"),
      text: t("aboutCard5Text"),
    },
    {
      key: "strengths",
      icon: "strengths",
      title: t("aboutCard6Title"),
      text: t("aboutCard6Text"),
    },
    {
      key: "domains",
      icon: "domains",
      title: t("aboutCard7Title"),
      text: t("aboutCard7Text"),
    },
    {
      key: "plan",
      icon: "plan",
      title: t("aboutCard8Title"),
      text: t("aboutCard8Text"),
    },
  ];

  return (
    <section className={styles.root} aria-labelledby="valueprops-title">
      <div className={styles.overlapShadow} aria-hidden />
      <div className={styles.container}>
        <h2 id="valueprops-title">{t("aboutTitle")}</h2>

        <p className={styles.subtitle}>{t("aboutSubtitle")}</p>

        <div className={styles.grid}>
          {items.map((it) => (
            <article key={it.key} className={styles.card}>
              <div className={styles.iconWrap}>
                <Icon name={it.icon} />
              </div>
              <div className={styles.cardBody}>
                <h3>{it.title}</h3>
                <p>{it.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
